export default "/images/404_page_not_found.png";